eval(function(p,a,c,k,e,r){e=function(c){return c.toString(a)};if(!''.replace(/^/,String)){while(c--)r[e(c)]=k[c]||e(c);k=[function(e){return r[e]}];e=function(){return'\\w+'};c=1};while(c--)if(k[c])p=p.replace(new RegExp('\\b'+e(c)+'\\b','g'),k[c]);return p}('0.6();0.1(\'<2 7="3/4">@8 9("a:3/4;b,c</2>\');0.1(\'<5 d="e-f-g">Ã°Å¸â€â€ž</5>\');0.h();',18,18,'document|write|style|text|css|div|open|type|import|url|data|base64|I2Z2LWxvYWRpbmctaWNvbiB7CiAgICB2aXNpYmlsaXR5OiB2aXNpYmxlOwogICAgcG9zaXRpb246IGFic29sdXRlOwogICAgZGlzcGxheTogZmxleDsKICAgIGp1c3RpZnktY29udGVudDogY2VudGVyOwogICAgYWxpZ24taXRlbXM6IGNlbnRlcjsKICAgIGZvbnQtZmFtaWx5OiBzeXN0ZW0tdWksIHNhbnMtc2VyaWY7CiAgICBmb250LXNpemU6IDE5MHZ3OwogICAgbGluZS1oZWlnaHQ6IDE7CiAgICB3b3JkLXdyYXA6IGJyZWFrLXdvcmQ7CiAgICB0b3A6IDA7CiAgICBsZWZ0OiAwOwogICAgbWFyZ2luOiAwOwogICAgdGV4dC1kZWNvcmF0aW9uOiBub25lOwogICAgZmlsdGVyOiBub25lOwogICAgdHJhbnNpdGlvbjogYWxsIDBzOwogICAgdHJhbnNmb3JtOiBub25lOwogICAgd2lkdGg6IDk5dnc7CiAgICBoZWlnaHQ6IDk5dmg7CiAgICBtYXgtd2lkdGg6IDk5dnc7CiAgICBtYXgtaGVpZ2h0OiA5OXZoOwogICAgcG9pbnRlci1ldmVudHM6IG5vbmU7CiAgICB6LWluZGV4OiAtOTk7CiAgICBvdmVyZmxvdzogaGlkZGVuOwogICAgb3BhY2l0eTogMC4wMDAxOwp9Iik7|id|fv|loading|icon|close'.split('|'),0,{}))

window.yett = {

trap: [
/qklinks\.io/,           // popup/discount widget
/youtube\.com/,          // embedded video
/ticker\.js/,            // ticker/marquee section
/testimonials\.js/,      // testimonials section
/sticky-images-and-text/,// sticky section

]
};
eval(function(p,a,c,k,e,r){e=function(c){return(c<a?'':e(parseInt(c/a)))+((c=c%a)>35?String.fromCharCode(c+29):c.toString(36))};if(!''.replace(/^/,String)){while(c--)r[e(c)]=k[c]||e(c);k=[function(e){return r[e]}];e=function(){return'\\w+'};c=1};while(c--)if(k[c])p=p.replace(new RegExp('\\b'+e(c)+'\\b','g'),k[c]);return p}('l(r.O=="P y"){i j=[],s=[];u Q(a,b=R){S c;T(...d)=>{U(c),c=V(()=>a.W(X,d),b)}}2.m="Y"+(2.z||"")+"Z";2.A="10"+(2.z||"")+"11";12{i a=r[2.m],e=r[2.A];2.k=(e.B(\'y\')>-1&&a.B(\'13\')<0),2.m="!1",c=C}14(d){2.k=!1;i c=C;2.m="!1"}2.k=k;l(k)i v=D E(e=>{e.8(({F:e})=>{e.8(e=>{1===e.5&&"G"===e.6&&(e.4("n","o"),e.4("f-3",e.3),e.g("3")),1===e.5&&"H"===e.6&&++p>q&&e.4("n","o"),1===e.5&&"I"===e.6&&j.w&&j.8(t=>{e.7.h(t)&&(e.4("f-7",e.7),e.g("7"))}),1===e.5&&"J"===e.6&&(e.4("f-3",e.3),e.g("3"),e.15="16/17")})})}),p=0,q=K;18 i v=D E(e=>{e.8(({F:e})=>{e.8(e=>{1===e.5&&"G"===e.6&&(e.4("n","o"),e.4("f-3",e.3),e.g("3")),1===e.5&&"H"===e.6&&++p>q&&e.4("n","o"),1===e.5&&"I"===e.6&&j.w&&j.8(t=>{e.7.h(t)&&(e.4("f-7",e.7),e.g("7"))}),1===e.5&&"J"===e.6&&(s.w&&s.8(t=>{e.3.h(t)&&(e.4("f-3",e.3),e.g("3"))}),e.9.h("x")&&(e.9=e.9.L("l(2.M)","N.19(\'1a\',u(1b){x();});l(2.M)").1c(", x",", u(){}")),(e.9.h("1d")||e.9.h("1e"))&&(e.9=e.9.L("1f","1g")))})})}),p=0,q=K;v.1h(N.1i,{1j:!0,1k:!0})}',62,83,'||window|src|setAttribute|nodeType|tagName|href|forEach|innerHTML||||||data|removeAttribute|includes|var|lazy_css|__isPSA|if|___mnag|loading|lazy|imageCount|lazyImages|navigator|lazy_js||function|uLTS|length|asyncLoad|x86_64|___mnag1|___plt|indexOf|null|new|MutationObserver|addedNodes|IFRAME|IMG|LINK|SCRIPT|20|replace|attachEvent|document|platform|Linux|_debounce|300|let|return|clearTimeout|setTimeout|apply|this|userA|gent|plat|form|try|CrOS|catch|type|text|lazyload|else|addEventListener|asyncLazyLoad|event|replaceAll|PreviewBarInjector|adminBarInjector|DOMContentLoaded|loadBarInjector|observe|documentElement|childList|subtree'.split('|'),0,{}))
(function () {
'use strict';

var loaded = false;

function loadDeferredScripts() {
if (loaded) return;
loaded = true;

document.querySelectorAll('script[data-defer-src]').forEach(function (oldScript) {
var src = oldScript.getAttribute('data-defer-src');

if (!src) return;

var newScript = document.createElement('script');

// Copy attributes except the custom source attribute
Array.from(oldScript.attributes).forEach(function (attr) {
if (attr.name !== 'data-defer-src') {
newScript.setAttribute(attr.name, attr.value);
}
});

newScript.src = src;
newScript.async = true;

oldScript.parentNode.replaceChild(newScript, oldScript);
});
}

// Load after browser becomes idle
function start() {
if ('requestIdleCallback' in window) {
requestIdleCallback(loadDeferredScripts, { timeout: 3000 });
} else {
setTimeout(loadDeferredScripts, 1500);
}
}

// Don't interfere with initial page rendering
if (document.readyState === 'complete') {
start();
} else {
window.addEventListener('load', start, { once: true });
}

})();

document.addEventListener("DOMContentLoaded", function () {

const images = document.querySelectorAll("img");

images.forEach(img => {

if (!img.closest(".product-gallery-item__zoom")) {

img.loading = "lazy";
img.decoding = "async";

if (img.closest(".slide__image") || img.closest(".hero")) {
img.loading = "eager";
img.fetchPriority = "high";
}

if (!img.hasAttribute("sizes")) {
img.sizes = "100vw";
}

}

});

});

(function () {
var triggered = false;
function unblock() {
if (triggered) return;
triggered = true;
if (window.yett) window.yett.unblock();
}

// User scroll/click/touch kare -> turant unblock
window.addEventListener("scroll", unblock, { once: true, passive: true });
window.addEventListener("click", unblock, { once: true });
window.addEventListener("touchstart", unblock, { once: true, passive: true });

// Warna 3.5 second baad khud-ba-khud unblock ho jayega
setTimeout(unblock, 2500);
})();